// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"price":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceFormat"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceRangeFormat"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyPrice_price",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "price",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "priceFormat",
                "variableName": "priceFormat"
              },
              {
                "kind": "Variable",
                "name": "priceRangeFormat",
                "variableName": "priceRangeFormat"
              }
            ],
            "kind": "FragmentSpread",
            "name": "PropertyPrice_propertyPrice"
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
};
})());

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
